import React from "react";
import HoverLink from "../../elements/HoverLink";
import {subduedTextColour} from "../../../style/styleConsts";
import styled from "styled-components";

const AuthorLink = styled(HoverLink)`
    margin-left: -8px;
    color: ${subduedTextColour};
    font-size: 12px;
    border: 0;
`;

const Container = styled.div`
    display: flex;
    border-bottom: 1px solid #979797;
`;

export const Author = ({authorId, authorName, authorCompanyName, linkClicked}) => (
    <AuthorLink to={`/author/${authorId}`}
                onClick={() => linkClicked("AUTHOR", {id: `${authorId}`, name: authorName})}>
        <Container>
            <div>{`${authorCompanyName} - ${authorName}`}</div>
        </Container>
    </AuthorLink>
);